module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img36.6ae7a91c.jpg";